/**
 * Semantic tokens — warm linen palette for light/dark mode.
 * Every surface, text, and border in the app references these tokens,
 * so changing values here transforms everything at once.
 */

export const semanticTokens = {
  colors: {
    // --- Surfaces ---
    'surface.page':      { default: 'linen.50',      _dark: 'linen.950' },
    'surface.card':      { default: 'white',          _dark: 'linen.800' },
    'surface.header':    { default: 'linen.100',      _dark: 'linen.900' },
    'surface.elevated':  { default: 'white',          _dark: 'linen.700' },
    'surface.input':     { default: 'white',          _dark: 'linen.800' },
    'surface.tip':       { default: 'butter.50',      _dark: 'rgba(255,217,102,0.08)' },
    'surface.overlay':   { default: 'blackAlpha.500', _dark: 'blackAlpha.700' },
    'surface.hover':     { default: 'linen.100',      _dark: 'linen.700' },
    'surface.active':    { default: 'sage.50',        _dark: 'rgba(91,138,91,0.15)' },
    'surface.nav':       { default: 'white',          _dark: 'linen.900' },

    // --- Text (light mode values tuned for WCAG AA on white/linen.50) ---
    'text.primary':      { default: 'linen.900',     _dark: 'linen.100' },
    'text.secondary':    { default: 'linen.700',     _dark: 'linen.400' },
    'text.muted':        { default: 'linen.600',     _dark: 'linen.500' },
    'text.tip':          { default: 'butter.800',    _dark: 'butter.300' },
    'text.accent':       { default: 'sage.700',      _dark: 'sage.300' },

    // --- Borders ---
    'border.subtle':     { default: 'linen.200',     _dark: 'linen.700' },
    'border.card':       { default: 'linen.200',     _dark: 'linen.700' },
    'border.focus':      { default: 'sage.400',      _dark: 'sage.300' },

    // --- Brand semantic aliases ---
    'brand.primary':     { default: 'sage.500',        _dark: 'sage.400' },
    'brand.hover':       { default: 'sage.600',        _dark: 'sage.300' },
    'brand.subtle':      { default: 'sage.50',         _dark: 'rgba(91,138,91,0.12)' },
    'accent.primary':    { default: 'terracotta.400',  _dark: 'terracotta.300' },
    'accent.subtle':     { default: 'terracotta.50',   _dark: 'rgba(240,128,64,0.10)' },
  },
};
